<template>
  <div>
    <b-row v-if="loading">
      <b-col cols="12">
        <loading-card />
      </b-col>
    </b-row>
    <b-row
      v-else
      match-height
    >
      <b-col
        cols="12"
      >
        <b-card>
          <b-row>
            <b-col cols="12">
              <primary-heading title-text="Genel Toplam" />
            </b-col>
            <b-col
              cols="12"
              md="8"
            >
              <b-row no-gutters>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="Stok"
                    :value="dayDurations.grandTotals.total_count"
                    icon="InfoIcon"
                    color="info"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="Bağlantı"
                    :value="dayDurations.grandTotals.connected"
                    icon="LinkIcon"
                    color="secondary"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="1-30 Gün"
                    :value="dayDurations.grandTotals.days_0_30"
                    icon="CheckCircleIcon"
                    color="success"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="31-60 Gün"
                    :value="dayDurations.grandTotals.days_31_60"
                    icon="AlertCircleIcon"
                    color="warning"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="61+ Gün"
                    :value="dayDurations.grandTotals.days_61"
                    icon="XCircleIcon"
                    color="danger"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  class="mb-1 mt-1"
                >
                  <flat-card
                    title="Valör"
                    :value="dayDurations.grandTotals.value_date"
                    icon="BarChartIcon"
                    color="info"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <pie-charts
                chart-title="Genel Toplam"
                :categories-data="dayDurations.grandTotals.chart.labels"
                :series-data="dayDurations.grandTotals.chart.series"
                :colors-data="colors"
                chart-type="donut"
                :is-card="false"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <template v-for="item in dayDurations.data">
        <b-col
          v-if="item.data.total_count"
          :key="item.id"
          cols="12"
        >
          <b-card>
            <b-row>
              <b-col cols="12">
                <primary-heading :title-text="item.title" />
              </b-col>
              <b-col
                cols="12"
                md="8"
              >
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="Stok"
                      :value="item.data.total_count"
                      icon="InfoIcon"
                      color="info"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="Bağlantı"
                      :value="item.data.connected"
                      icon="LinkIcon"
                      color="secondary"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="1-30 Gün"
                      :value="item.data.days_0_30"
                      icon="CheckCircleIcon"
                      color="success"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="31-60 Gün"
                      :value="item.data.days_31_60"
                      icon="AlertCircleIcon"
                      color="warning"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="61+ Gün"
                      :value="item.data.days_61"
                      icon="XCircleIcon"
                      color="danger"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    class="mb-1 mt-1"
                  >
                    <flat-card
                      title="Valör"
                      :value="item.data.value_date"
                      icon="BarChartIcon"
                      color="info"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="item.chart"
                cols="12"
                md="4"
              >
                <pie-charts
                  :chart-title="item.title"
                  :categories-data="item.chart.labels"
                  :series-data="item.chart.series"
                  :colors-data="colors"
                  chart-type="donut"
                  :is-card="false"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'
import PrimaryHeading from '@/layouts/components/PrimaryHeading.vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'DayDurations',
  components: {
    BCard,
    BRow,
    BCol,
    FlatCard,
    PrimaryHeading,
    LoadingCard,
    PieCharts,
  },
  computed: {
    loading() {
      return this.$store.getters['saleStocksReports/loading']
    },
    dayDurations() {
      return this.$store.getters['saleStocksReports/dayDurations']
    },
    colors() {
      return [
        '#28c76f',
        '#ff9f43',
        '#ea5455',
      ]
    },
  },
  created() {
    this.getDaydurations()
  },
  methods: {
    getDaydurations() {
      this.$store.dispatch('saleStocksReports/getDaydurations')
    },
  },
}
</script>
